import { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination/Pagination';
import TableClients from '../../components/DataTable/TableClients';
import { columnsMyRequestsEmployee, statuses } from './helpers/MyRequestsEmployeeUtils';
import myRequestsEmployeeHttp from '../../http/myRequestsEmployeeHttp/myRequestsEmployeeHttp';
import { useLocation, useNavigate } from 'react-router-dom';
import { afterAPICall } from '../Payments/helpers/PaymentUtils';
import requestHttp from '../../http/requestHttp/requestHttp';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import TitleBlockRequest from '../../components/TitleBlockRequest/TitleBlockRequest';

export default function MyRequestsEmployee() {
  const { state } = useLocation();
  const [myRequestsList, setMyRequestsList] = useState([]);
  const [myRequestsListPage, setMyRequestsListPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);

  const [dataClientCurrent, setDataClientCurrent] = useState(state?.client ?? '');
  const [dataStatusCurrent, setDataStatusCurrent] = useState(state?.status ?? '');
  const [currentPage, setCurrentPage] = useState(state?.page ?? '');
  const [AllClientsData, setAllClientsData] = useState([]);

  const navigate = useNavigate();

  const fetchMyRequests = async (pageId = '', dataClientCurrent, dataStatusCurrent) => {
    setLoading(true);
    try {
      const response = await myRequestsEmployeeHttp.employeeRequestsLinks(pageId, dataClientCurrent, dataStatusCurrent);
      setMyRequestsList(response?.data?.data || []);
      setMyRequestsListPage(response?.data || {});
    } catch (err) {
      console.error('Error fetching company forms:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyRequests(currentPage, dataClientCurrent, dataStatusCurrent);
    myRequestsEmployeeHttp.employeeRequestClientsLinks().then(e => {
      e?.data?.data.unshift({ name: 'All Clients', id: '' });
      setAllClientsData(e?.data?.data);
    });
  }, [reload, dataStatusCurrent, dataClientCurrent, currentPage]);

  const handlePaginationClick = id => {
    fetchMyRequests(id, dataClientCurrent, dataStatusCurrent);
  };

  const onClickDetails = (id, currentPage, dataClientCurrent, dataStatusCurrent) => {
    navigate(`/Employee/ViewRequestForm/${id}`, {
      state: { page: currentPage, client: dataClientCurrent, status: dataStatusCurrent },
    });
  };

  const onClickComplete = id => {
    requestHttp
      .completeRequestForEmployee(id)
      .then(e => afterAPICall('Status Successfully Changed'))
      .then(() => setReload(prev => !prev));
  };
  const onClickUnComplete = id => {
    requestHttp
      .unCompleteRequestForEmployee(id)
      .then(e => afterAPICall('Status Successfully Changed'))
      .then(() => setReload(prev => !prev));
  };

  return (
    <div className="sm:px-8 px-4 py-8 w-full">
      {/* <TitleBlok textItem="My Requests" className="text-base font-semibold" src="/CompanyFormsIcon.svg" /> */}
      <TitleBlockRequest
        src={'/InvoicesIcon.svg'}
        textItem={'Requests'}
        className="text-base font-bold"
        AllClientsData={AllClientsData}
        setDataClientCurrent={setDataClientCurrent}
        statuses={statuses}
        setDataStatusCurrent={setDataStatusCurrent}
        button={false}
        valueStatus={dataStatusCurrent}
        valueClient={dataClientCurrent}
        setCurrentPage={setCurrentPage}
      />
      <div className="px-4 py-1 mt-4 bg-white rounded-xl">
        <div className={`w-full overflow-x-auto  ${loading && `animate-pulse`}`}>
          <div className="inline-block min-w-full">
            <TableClients
              tbody={myRequestsList}
              columns={columnsMyRequestsEmployee(
                onClickDetails,
                onClickComplete,
                onClickUnComplete,
                myRequestsListPage?.links?.current_page,
                dataClientCurrent,
                dataStatusCurrent,
              )}
              maxHeight="500px"
            />
          </div>
        </div>
        <Pagination onPaginationClick={handlePaginationClick} paginationData={myRequestsListPage?.links} />
      </div>
      <ToastContainer />
    </div>
  );
}
